export const designSystemTheme = {
  breakPoints: {
    mobile: 441,
    tablet: 680,
    readable: 800,
    medium: 900,
    maximum: 1400,
  },
};
